import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

const operators = ["Equals", "Not equals"];

// This component will be rendered when the hamburger icon next to column name is clicked on,
// assuming the column contains a discrete set of options such as "status".
// It will show a menu with two drop down where the first is "Equals" and "Not equals".
// The second drop down will contain the options for that attribute.
export default forwardRef((props, ref) => {
  const { filterChangedCallback, values, valueGetter } = props;
  const [operator, setOperator] = useState(operators[0]);
  const [filterOperator, setFilterOperator] = useState(operators[0]);
  const [value, setValue] = useState("");
  const [filterValue, setFilterValue] = useState("");

  // Expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const value = valueGetter(params);
        switch (filterOperator) {
          case "Equals":
            if (value === undefined) {
              /* Value might be undefined when e.g. a field is not available upon submission.  */
              return false;
            }
            return filterValue.toLowerCase() === value.toString().toLowerCase();
          case "Not equals":
            if (value === undefined) {
              return true;
            }
            return filterValue.toLowerCase() !== value.toString().toLowerCase();
          default:
            return false;
        }
      },

      isFilterActive() {
        return filterValue != null && filterValue !== "";
      },

      getModel() {
        return { value: filterValue };
      },

      setModel(model) {
        setFilterValue(model.value);
      },
    };
  });

  const onApply = (e) => {
    setFilterValue(value);
    setFilterOperator(operator);
  };

  const onReset = (e) => {
    setValue("");
    setFilterValue("");
    setOperator(operators[0]);
  };

  useEffect(() => {
    filterChangedCallback();
  }, [filterValue, filterOperator, filterChangedCallback]);

  return (
    <div
      className="ag-ltr ag-popup-child"
      style={{ minWidth: "148px", left: "339px", top: "46px" }}
    >
      <div className="ag-filter">
        <div className="ag-filter-wrapper">
          <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
            <div className="ag-filter-body">
              <div className={"ag-filter-select ag-labeled ag-select"}>
                <select
                  className={"ag-wrapper ag-picker-field-wrapper"}
                  value={operator}
                  onChange={(e) => setOperator(e.target.value)}
                >
                  {operators.map((status, index) => (
                    <option key={index} className={"ag-picker-field-display"}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ag-filter-body ag-focus-managed">
                <div className="ag-filter-select ag-labeled ag-select">
                  <select
                    className={"ag-wrapper ag-picker-field-wrapper"}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                  >
                    <option className={"ag-picker-field-display"} />
                    {values.map((status, index) => (
                      <option key={index} className={"ag-picker-field-display"}>
                        {status}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="ag-filter-apply-panel">
                <button
                  type="button"
                  className="ag-standard-button ag-filter-apply-panel-button"
                  onClick={onApply}
                >
                  Apply
                </button>
                <button
                  type="button"
                  className="ag-standard-button ag-filter-apply-panel-button"
                  onClick={onReset}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
